<script setup>
import TheFooter from '@/components/Layout/Components/TheFooter.vue';
import TheHeader from '@/components/Layout/Components/TheHeader.vue';
import TheDevBar from '@/components/TheDevBar.vue';
import ErrorMessage from '@/components/Views/Funnels/shared/all-funnels/components/ErrorMessage.vue';
import { formStore } from '@/stores/form.js';
import { computed } from 'vue';

const form = formStore();

const hideUspSection = computed(() => ['insuretostudy', 'eerdmans'].includes(form.tenant));
const hideChatBox = computed(() => ['insuretostudy', 'eerdmans'].includes(form.tenant));
const hideHelpCenter = computed(() => ['insuretostudy'].includes(form.tenant));
const hideFooter = computed(() => ['insuretostudy', 'eerdmans'].includes(form.tenant));
</script>

<template>
  <div class="wrapper">
    <BaseSpinner v-if="form.baseSpinner" />
    <BaseLoader v-if="form.baseLoader" />
    <TheDevBar v-if="form.getFunnelVersion === 'dev-local' || form.devMode" />
    <TheHeader
      :disabled-usp-section="hideUspSection"
      :disabled-chat-box="hideChatBox"
      :disabled-help-center="hideHelpCenter"
    />
    <main>
      <div class="container">
        <ErrorMessage v-if="form.error" />
      </div>
      <slot />
    </main>
    <!-- The footer -->
    <TheFooter v-if="!hideFooter" />
  </div>
</template>
